import logoNew from "../../../assets/logo-new.png";

function NavBarComponent({ isUserLoggedIn }) {
  return (
    <div style={{ height: "5%" }}>
      <nav className="navbar navbar-expand-lg navbar-light bg-custom">
        {/* <!-- Container wrapper --> */}
        <div className="container-fluid p-0">
          {/* <!-- Toggle button --> */}

          <a className="navbar-brand mt-2 mt-lg-0" href="/home">
            <img src={logoNew} height="50" alt="Emalpha Log" loading="lazy" />
          </a>

          <div className="d-flex align-items-center">
            <div className="p-3">
              <a className="nav-link" href="/login">
                Login
              </a>
            </div>
            <div className="p-3">
              <a className="nav-link" href="/signup">
                SignUp
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default NavBarComponent;
